export default {
  report: null,
  loading: false,
  error: null,
  message: null,
  dailyRevenueError: null,
  cogsError: null,
  incomingInvoicesError: null,
  cogsMessage: null,
  incomingInvoicesMessage: null,
  dailyRevenueMessage: null
} 